import {GlobalRenderConstants} from "#template/interfaces/scene-object"

// A light of type Blender is given in watts, as Blender measures it; the platform renders it by the radiance over its surface.
const wattsPerRadiance = (surfaceM2: number) => Math.PI * GlobalRenderConstants.lightIntensityScale * surfaceM2

const rectangleM2 = (widthCm: number, heightCm: number) => (widthCm / 100) * (heightCm / 100)
const sphereM2 = (radiusCm: number) => 4 * Math.PI * (radiusCm / 100) ** 2

export const areaLightRadiance = (watts: number, widthCm: number, heightCm: number) => watts / wattsPerRadiance(rectangleM2(widthCm, heightCm))
export const areaLightWatts = (radiance: number, widthCm: number, heightCm: number) => radiance * wattsPerRadiance(rectangleM2(widthCm, heightCm))

export const pointLightRadiance = (watts: number, radiusCm: number) => watts / wattsPerRadiance(sphereM2(radiusCm))
export const pointLightWatts = (radiance: number, radiusCm: number) => radiance * wattsPerRadiance(sphereM2(radiusCm))
